<template>
  <v-container fluid>
    <v-data-table
      :headers="headers"
      class="elevation-1"
      :items="formas"
      :loading="loading"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-spacer />
          <v-btn
            v-if="perms.includes('formapgto.editar')"
            depressed
            color="accent"
            :to="{ name: 'forma-pagamento-formulario' }"
          >
            <v-icon class="mr-2">mdi-credit-card-plus-outline</v-icon>Novo
            cadastro
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn
          v-if="perms.includes('formapgto.editar')"
          icon
          small
          text
          @click="editar(item.id)"
        >
          <v-icon class="mdi mdi-pencil" small />
        </v-btn>
        <dialog-confirm
          titulo="Deletar Forma de Pagamento"
          texto="Confirma a exclusão?"
          @confirmar="deletar(item.id)"
          v-if="perms.includes('formapgto.excluir')"
        >
          <v-btn icon small text>
            <v-icon class="mdi mdi-delete" small />
          </v-btn>
        </dialog-confirm>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import DialogConfirm from "../components/DialogConfirm";
export default {
  components: { DialogConfirm },
  data() {
    return {
      headers: [
        { text: "Descrição", value: "descricao" },
        { text: "Cód NFE", value: "codigo_nfe" },
        { text: "Ações", value: "actions", sortable: false, align: "center" },
      ],
      loading: true,
      dialogConfirm: false,
    };
  },
  computed: {
    ...mapState({
      perms: (state) => state.usuarios.usuarioAtivo.permissoes,
    }),
    formas() {
      return this.$store.state.formaPgto.formasPagamentos;
    },
  },
  methods: {
    async deletar(id) {
      this.loading = true;
      await this.$store.dispatch("formaPgto/deletar", { id });

      this.listar();
    },
    editar(id) {
      this.$router.replace({
        path: "editar",
        name: "forma-pagamento-formulario-editar",
        params: { id },
      });
    },
    async listar() {
      this.loading = true;
      try {
        await this.$store.dispatch("formaPgto/listar", {});
      } catch (e) {
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível carregar lista de formas de pagamento",
        });
      }
      this.loading = false;
    },
  },
  mounted() {
    this.$store.commit("ui/changeToolbar", {
      title: "Cadastro de formas de pagamento",
    });
    this.listar();
  },
};
</script>
